/**
   * Function: button_pending
   * @description This adds a spinner to the button, adds a class and disables it
   *
   * @param {String} selector The button selector
   * @param {String} label (optional) The label to display next to the spinner
*/
export const button_pending = (selector, label) => selector.html(`<i data-icon="spinner" class="icon fa fa-spinner fa-spin"></i> ${label}`).addClass('submitting').prop('disabled', true)

/**
   * Function: button_reset
   * @description This removes the spinner in the button, removes a class and enables it
   *
   * @param {String} selector The button selector
   * @param {String} label (optional) The label to display next to the spinner
*/
export const button_reset = (selector, label) => selector.html(`${label}`).removeClass('submitting').prop('disabled', false)

/**
 * Function: dynamic_form_element
 * @see /template/components/forms/dynamic.twig
 * @description Dynamically adds and removes form elements based on user interaction.
 * This function allows users to add multiple elements or remove existing ones
 * by clicking designated buttons. The newly added elements are cloned from a template
 * element defined in the DOM.
 *
 * @param {string} id - The data attribute ID used to identify the form elements.
 *
 * @note These attribute IDs should be defined in the HTML elements that will be used for adding and removing form elements.
 * They must be unique if adding multiple dynamic form elements on the same page.
 */
export const dynamic_form_element = id => {
   const add_field_button = `[data-dynamic-form-element="${id}_add_button"]`
   const remove_field_button = `[data-dynamic-form-element="${id}_remove_button"]`
   const form_element = `[data-dynamic-form-element="${id}_element"]`
   const clone_element = $(`[data-dynamic-form-element="${id}_fresh"]`)
   const element_container = `[data-dynamic-form-element="${id}_container"]`

   // Adds a new cloned field on page load
   $(document).ready(() => {
      // Only clone if the container has no children (form_element) - excluding the clonable field.
      const existingElements = $(element_container).children(form_element);
      if (existingElements.length === 0) {
         clone_fresh_element();
         toggleElement(element_container);
      }
   });

   // Adds a new cloned field on click
   $(document).on('click', add_field_button, () => {
      clone_fresh_element()
      toggleElement(element_container)
   })

   // Removes a field on click
   $(document).on('click', remove_field_button, function() {
      $(this).closest(form_element).remove()
      toggleElement(element_container)
   })

   // Clone a fresh element
   const clone_fresh_element = () => clone_element.children(':first-child').clone().appendTo(element_container)
}
/**
   * Function: toggleElement
   * @description Checks if the element has children or not and toggles the class
   * @param {string} element the element to check
*/
const toggleElement = (element) => {
   if ($(element).length > 0 && $(element).children().length) {
      $(element).removeClass('d-none');
  } else if($(element).length > 0 && ! $(element).children().length) {
      $(element).addClass('d-none');
  }
}